import React from "react";
import { Box, Grid2 } from "@mui/material";
import PageTitle from "../../../components/Common/PageTitle/index";
import ContentCard from "../../../components/Content/ContentCard/index";
import LinkBox from "../../../components/Content/LinkBox";
import {
  PAGE_TITLE,
  PAGE_TEXT,
  VIDEO_URL,
  SECTION_TITLE,
  FOOTER_TEXT_CEU_LIST,
  LINK_BOX_TITLE,
  LINK_BOX_URL,
  FOOTER_TEXT_OTHER_CEUS,
  FOOTER_TEXT_STAYING_CURRENT,
  COURSES_DATA,
} from "./Courses.constants";
import {
  RootBox,
  SectionTitleTypography,
  FooterTypography,
  FooterTypographyTight,
} from "./Courses.styles";

const Courses = () => {
  const handleCardClick = (link) => () => window.open(link, "_blank");

  return (
    <RootBox>
      <PageTitle
        title={PAGE_TITLE}
        text={PAGE_TEXT}
        noIcon
        videoUrl={VIDEO_URL}
      />

      <Grid2 container spacing={2} sx={{ mt: 4 }}>
        <Grid2 item size={{ xs: 12 }}>
          <SectionTitleTypography>{SECTION_TITLE}</SectionTitleTypography>
        </Grid2>

        {COURSES_DATA.map((item) => (
          <Box
            key={item.id}
            sx={{ minWidth: 200, maxWidth: 300, margin: "auto" }}
          >
            <ContentCard
              item={item}
              height="auto"
              clickable
              onClick={handleCardClick(item.link)}
              image={item.image}
            />
          </Box>
        ))}
      </Grid2>

      <FooterTypography>{FOOTER_TEXT_CEU_LIST}</FooterTypography>
      <LinkBox title={LINK_BOX_TITLE} link={LINK_BOX_URL} />

      <FooterTypographyTight>{FOOTER_TEXT_OTHER_CEUS}</FooterTypographyTight>
      <FooterTypographyTight>
        {FOOTER_TEXT_STAYING_CURRENT}
      </FooterTypographyTight>
    </RootBox>
  );
};

export default Courses;
